// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-form-wizard[data-v-0f2c993a]  .wizard-nav-pills{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.vue-form-wizard[data-v-0f2c993a]  .wizard-nav-pills li{padding-bottom:10px!important;pointer-events:none!important}.vue-form-wizard[data-v-0f2c993a]  .wizard-tab-content{-webkit-box-shadow:none!important;box-shadow:none!important;background:transparent!important;padding:0}", ""]);
// Exports
module.exports = exports;
